import CRUDActions from '../CRUD';
import {LiveStadiumStreamEvent} from '../../api/stream/LiveStadiumStreamEvent';

export class StreamActions extends CRUDActions {
  prefix = 'stream_event';

  get _model() {
    return LiveStadiumStreamEvent;
  }

  /**
   *
   * @param {} model
   * @returns {function(*)}
   */
  publish(model: LiveStadiumStreamEvent, data: any) {
    return async (dispatch) => {
      dispatch({
        type: this.saveItemAction,
        id: model.id
      });
      try {
        let updatedModel = await model.publish(data);

        dispatch({
          type: this.saveItemFinishedSuccessAction,
          model: updatedModel
        });

        return true;
      }
      catch (error) {
        dispatch({
          type: this.saveItemFinishedFailAction,
          error
        });
        return false;
      }
    }
  }
}

export const streamAction = new StreamActions();



// WEBPACK FOOTER //
// ./src/actions/stream/liveStadiumStream.ts